<template>
  <!--
    Dialog de tutoriais em vídeo.
    Comportamento:
      - Se a rota tiver 1 vídeo: abre direto no player.
      - Se tiver 2+: exibe lista de seleção primeiro.
    O botão de voltar (←) só aparece quando há mais de um vídeo na lista.
  -->
  <v-dialog v-model="show" max-width="860" @click:outside="fechar">
    <v-card>
      <v-toolbar dark color="blue darken-3" dense>
        <!-- Mostra botão voltar apenas quando um vídeo está sendo assistido e há lista para retornar -->
        <v-btn v-if="selecionado" icon @click="voltarLista">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon v-else left>mdi-help-circle-outline</v-icon>
        <v-toolbar-title>{{ selecionado ? selecionado.titulo : 'Tutoriais disponíveis' }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Lista de vídeos: exibida quando há múltiplos tutoriais e nenhum foi selecionado ainda -->
      <v-card-text v-if="!selecionado" class="pa-4">
        <v-list two-line>
          <v-list-item
            v-for="(item, index) in lista"
            :key="index"
            @click="assistir(item)"
            style="cursor: pointer;"
          >
            <v-list-item-avatar color="blue darken-3">
              <v-icon dark>mdi-play</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="blue darken-3">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <!-- Player de vídeo: renderizado apenas quando um item está selecionado -->
      <v-card-text v-if="selecionado" class="pa-0">
        <!--
          controlsList="nodownload" remove o botão nativo de download do browser.
          max-height: 70vh evita que o player ultrapasse a tela em monitores pequenos.
        -->
        <video
          ref="player"
          :src="selecionado.url"
          controls
          controlsList="nodownload"
          style="width: 100%; display: block; max-height: 70vh; background: #000;"
        >
          Seu navegador não suporta reprodução de vídeo.
        </video>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TutorialVideoDialog',
  data: () => ({
    show: false,
    lista: [],       // todos os tutoriais disponíveis para a rota atual
    selecionado: null, // tutorial em reprodução; null = exibe a lista
  }),
  methods: {
    // Chamado pelo plugin $tutorial.abrir() a partir de qualquer tela
    abrir(lista) {
      this.lista = lista
      // Com apenas 1 vídeo, pula a lista e vai direto ao player
      this.selecionado = lista.length === 1 ? lista[0] : null
      this.show = true
    },

    // Seleciona um vídeo da lista para reprodução
    assistir(item) {
      this.selecionado = item
    },

    // Volta para a lista sem fechar o dialog
    voltarLista() {
      // Pausa e reseta o player antes de escondê-lo para evitar áudio em background
      if (this.$refs.player) {
        this.$refs.player.pause()
        this.$refs.player.currentTime = 0
      }
      this.selecionado = null
    },

    // Fecha o dialog e garante que o vídeo para completamente
    fechar() {
      if (this.$refs.player) {
        this.$refs.player.pause()
        this.$refs.player.currentTime = 0
      }
      this.show = false
      this.selecionado = null
    },
  },
}
</script>
